module.exports = __webpack_public_path__ + "img/pt_slider_power.2ec0102a.png";